module.exports = __webpack_public_path__ + "static/img/picc6.6887995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picc6.png
// module id = X5tE
// module chunks = 0